import { useSelector } from "react-redux";
import { ICustomerProfileClientState } from "@telstra-connect/tokens/state";
import {
    ISignInState,
    IUserManagementClientState,
} from "@telstra-connect/login/state";
import { UserType } from "@telstra-connect/utils/data";

/**
 * Custom hook to determine the appropriate customer ID (cidn) based on the user's type.
 *
 * This hook retrieves customer profile information, user's company ID, and staff user's
 * selected company ID from the Redux store. It then returns the correct cidn based on
 * whether the user is a staff user or a regular customer.
 *
 * @returns {object} An object containing the customer ID (cidn).
 * @returns {string} .userCidn - The appropriate customer ID based on the user's type.
 */
const useCustomerTypeCidn = () => {
    const customerType = useSelector(
        (state: ICustomerProfileClientState) =>
            state?.tokens?.customerProfile?.data?.profile
    );
    // Retrieve the user's company ID (cidn) from the sign-in state
    const customerCidn: string = useSelector(
        (state: ISignInState) => state?.user?.oauth?.profile?.companyId
    );
    // Retrieve the staff user's company ID (cidn)
    const staffCidn: string = useSelector(
        (state: IUserManagementClientState) =>
            state?.userManagement?.preferences?.data?.lastSelectedCompanies[0].cidn
    );

    return {
        userCidn: customerType === UserType.staffUser ? staffCidn : customerCidn,
    };
};

export default useCustomerTypeCidn;
